<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    :class="cls"
    @update:modelValue="update"
  >
    <el-option
      v-for="type in ContactTypeLabels"
      :key="type.label"
      :label="type.label"
      :value="type.id"
    >
      {{ type.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { ContactTypeLabels, ContactType } from '@/api/types'

export default defineComponent({
  name: 'TaxStatusSelect',
  props: {
    modelValue: {
      type: String,
      default: ContactType.Personal
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cls: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = function (newValue: string) {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, ContactTypeLabels, value }
  }
})
</script>
